import { signal } from '@angular/core';

export const showPriceBreakdown = signal(false);
